export default __webpack_public_path__ + "static/media/NTEX.add9cb01.pdf";